import { render, staticRenderFns } from "./NewLostBacklinks.vue?vue&type=template&id=583442ac&scoped=true&"
import script from "./NewLostBacklinks.vue?vue&type=script&lang=js&"
export * from "./NewLostBacklinks.vue?vue&type=script&lang=js&"
import style0 from "./NewLostBacklinks.vue?vue&type=style&index=0&id=583442ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583442ac",
  null
  
)

/* custom blocks */
import block0 from "./NewLostBacklinks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports